import React from 'react';
import { useBrowser } from '../use-browser/use-browser.js';

/**
 * @since 12.5.0 as `useLockBodyScroll`
 * @since 10.0.0 as `useBodyStyleModifications`
 *
 * A hook that blocks the document body from scrolling when active.
 */
function useLockBodyScroll(active) {
  const [, doc] = useBrowser();
  /**
   * When the modal is opened should block users from scrolling the document body.
   * This does not happen when is not modal (hasOverlay = false) or if customer has disabled it.
   */
  React.useLayoutEffect(() => {
    if (doc !== null) {
      const scrollbarWidth = Math.abs(doc.defaultView.innerWidth - doc.documentElement.clientWidth);
      const scrollBarInPix = "".concat(scrollbarWidth, "px");
      if (active) {
        doc.body.style.overflow = 'hidden';
        doc.body.style.paddingRight = scrollBarInPix;
      } else {
        doc.body.style.removeProperty('overflow');
        doc.body.style.removeProperty('padding-right');
      }
    }
    // removing overflow when component is unmounted
    return () => {
      if (doc !== null) {
        const scrollbarWidth = Math.abs(doc.defaultView.innerWidth - doc.documentElement.clientWidth);
        const scrollBarInPix = "".concat(scrollbarWidth, "px");
        if (doc.body.style.overflow === 'hidden') {
          doc.body.style.removeProperty('overflow');
        }
        if (doc.body.style.paddingRight === scrollBarInPix) {
          doc.body.style.removeProperty('padding-right');
        }
      }
    };
  }, [doc, active]);
}

export { useLockBodyScroll };
